import { useContext } from "react";
import { PositionContext } from "..";
import { POSITIONS_MAP } from "../constants";

export const usePosition = () => {
  const positionFromContext = useContext(PositionContext);

  return POSITIONS_MAP[positionFromContext];
};
